import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDataWAuth } from "../../../utils/api-service";
import { IB_BP_RATE_STATUS_LIST } from "../../../constants/constant";


export const fetchRatesStatus = createAsyncThunk(
  "ratesStatus/fetchRatesStatus",
  async (fisMonthYear, { rejectWithValue }) => {
    try {
      const response = await getDataWAuth(IB_BP_RATE_STATUS_LIST, { fisMonthYear });
      
      if (response.data.length > 0) {
        const sortedData = [
          response.data.find((role) => role.role === "BKP"),
          ...response.data.filter((role) => role.role === "CCM"),
        ];

        const allFrozen = sortedData.every((role) => role && role.freezed === true);
        
        return {
          ratesStatus: sortedData,
          isLocked: allFrozen,
        };
      } else {
        return {
          ratesStatus: [],
          isLocked: false,
        };
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ratesStatusSlice = createSlice({
  name: "ratesStatus",
  initialState: {
    ratesStatus: [],
    isLocked: false,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRatesStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRatesStatus.fulfilled, (state, action) => {
        state.ratesStatus = action.payload.ratesStatus;
        state.isLocked = action.payload.isLocked;
        state.isLoading = false;
      })
      .addCase(fetchRatesStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default ratesStatusSlice.reducer;
